import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, untracked } from '@angular/core';
import { SKIP_AUTH_HEADER } from '@core/constants/AUTH';
import { jwtCredentials } from '@core/signals/auth.signal';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const shouldSkipAuth =
      request.headers.has(SKIP_AUTH_HEADER) &&
      request.headers.get(SKIP_AUTH_HEADER)?.toLowerCase() === 'true';
    if (shouldSkipAuth) {
      const cleanedRequest = request.clone({
        headers: request.headers.delete(SKIP_AUTH_HEADER),
      });
      return next.handle(cleanedRequest);
    }

    const token = untracked(() => jwtCredentials()?.accessToken);
    if (token) {
      return next.handle(
        request.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        }),
      );
    }

    return next.handle(request);
  }
}
